import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog-form__content" }
const _hoisted_2 = { key: 1 }

import { Dialog as KDialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import { Button as KButton } from '@progress/kendo-vue-buttons';
import useTranslations from '@/composables/useTranslations';
import { useMagicKeys, whenever } from '@vueuse/core';
import { ref, watch } from 'vue';
import { Notification as KNotification } from '@progress/kendo-vue-notification';
import LoaderButton from '@/components/common/loaders/LoaderButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogForm',
  props: {
  title: { type: String, required: true },
  confirmButtonText: { type: String, required: false, default: null },
  cancelButtonText: { type: String, required: false, default: null },
  confirmButtonDisabled: { type: Boolean, required: false, default: false },
  successNotification: { type: [String, null], required: false, default: null },
  errorNotification: { type: [Array<string>, null], required: false, default: null },
  isLoading: { type: Boolean, required: true },
},
  emits: ['close', 'cancel-btn-clicked', 'confirm-btn-clicked'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
__expose({ hideFormContent, hideConfirmBtn });

const { translate: t } = useTranslations();
const keys = useMagicKeys();

const cancelBtnText = ref<string>(props.cancelButtonText);
const isConfirmBtnVisible = ref<boolean>(true);
const isFormVisible = ref<boolean>(true);

function handleCancelBtnClick() {
  emit('cancel-btn-clicked');
}

function handleConfirmBtnClick() {
  emit('confirm-btn-clicked');
}

function hideFormContent() {
  isFormVisible.value = false;
}

function hideConfirmBtn() {
  cancelBtnText.value = t('Ok');
  isConfirmBtnVisible.value = false;
}

watch(
  () => props.cancelButtonText,
  (newCancelButtonText) => {
    cancelBtnText.value = newCancelButtonText;
  },
);

whenever(keys.escape, () => {
  emit('close');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KDialog), {
    class: "dialog-form",
    title: __props.title,
    onClose: _cache[0] || (_cache[0] = () => _ctx.$emit('close'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.errorNotification)
          ? (_openBlock(), _createBlock(_unref(KNotification), {
              key: 0,
              type: { style: 'error' }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errorNotification, (error, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.successNotification)
          ? (_openBlock(), _createBlock(_unref(KNotification), {
              key: 1,
              type: { style: 'success' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.successNotification), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (isFormVisible.value)
          ? _renderSlot(_ctx.$slots, "default", { key: 2 })
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(DialogActionsBar), { layout: 'center' }, {
        default: _withCtx(() => [
          _createVNode(_unref(KButton), {
            "data-testid": "dialog-form__cancel-btn",
            "fill-mode": 'flat',
            size: 'medium',
            "theme-color": 'secondary',
            type: 'cancel',
            onClick: handleCancelBtnClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(cancelBtnText.value || _unref(t)('Cancel')), 1)
            ]),
            _: 1
          }),
          (isConfirmBtnVisible.value)
            ? (_openBlock(), _createBlock(_unref(KButton), {
                key: 0,
                "fill-mode": 'flat',
                size: 'medium',
                "theme-color": 'primary',
                type: 'submit',
                disabled: __props.confirmButtonDisabled,
                "data-testid": "dialog-form__confirm-btn",
                onClick: handleConfirmBtnClick
              }, {
                default: _withCtx(() => [
                  (__props.isLoading)
                    ? (_openBlock(), _createBlock(LoaderButton, {
                        key: 0,
                        "theme-color": 'primary'
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.confirmButtonText || _unref(t)('Send')), 1))
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["title"]))
}
}

})